// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState } from './GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState';
import {
  GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSON,
  GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSONTyped,
  GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateToJSON,
  GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateToJSONTyped,
} from './GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState';
import type { V1MemorySpec } from './V1MemorySpec';
import {
  V1MemorySpecFromJSON,
  V1MemorySpecFromJSONTyped,
  V1MemorySpecToJSON,
  V1MemorySpecToJSONTyped,
} from './V1MemorySpec';
import type { V1AdditionalSettings } from './V1AdditionalSettings';
import {
  V1AdditionalSettingsFromJSON,
  V1AdditionalSettingsFromJSONTyped,
  V1AdditionalSettingsToJSON,
  V1AdditionalSettingsToJSONTyped,
} from './V1AdditionalSettings';
import type { V1ClusterDatabasesReconcilerSpec } from './V1ClusterDatabasesReconcilerSpec';
import {
  V1ClusterDatabasesReconcilerSpecFromJSON,
  V1ClusterDatabasesReconcilerSpecFromJSONTyped,
  V1ClusterDatabasesReconcilerSpecToJSON,
  V1ClusterDatabasesReconcilerSpecToJSONTyped,
} from './V1ClusterDatabasesReconcilerSpec';
import type { V1Neo4jMajorVersion } from './V1Neo4jMajorVersion';
import {
  V1Neo4jMajorVersionFromJSON,
  V1Neo4jMajorVersionFromJSONTyped,
  V1Neo4jMajorVersionToJSON,
  V1Neo4jMajorVersionToJSONTyped,
} from './V1Neo4jMajorVersion';
import type { V1ResourcePolicyOverride } from './V1ResourcePolicyOverride';
import {
  V1ResourcePolicyOverrideFromJSON,
  V1ResourcePolicyOverrideFromJSONTyped,
  V1ResourcePolicyOverrideToJSON,
  V1ResourcePolicyOverrideToJSONTyped,
} from './V1ResourcePolicyOverride';
import type { V1SourceBackup } from './V1SourceBackup';
import {
  V1SourceBackupFromJSON,
  V1SourceBackupFromJSONTyped,
  V1SourceBackupToJSON,
  V1SourceBackupToJSONTyped,
} from './V1SourceBackup';
import type { V1StorageClassSettings } from './V1StorageClassSettings';
import {
  V1StorageClassSettingsFromJSON,
  V1StorageClassSettingsFromJSONTyped,
  V1StorageClassSettingsToJSON,
  V1StorageClassSettingsToJSONTyped,
} from './V1StorageClassSettings';
import type { V1DiskSpec } from './V1DiskSpec';
import {
  V1DiskSpecFromJSON,
  V1DiskSpecFromJSONTyped,
  V1DiskSpecToJSON,
  V1DiskSpecToJSONTyped,
} from './V1DiskSpec';

/**
 *
 * @export
 * @interface V1Neo4jClusterSpec
 */
export interface V1Neo4jClusterSpec {
  /**
   *
   * @type {V1AdditionalSettings}
   * @memberof V1Neo4jClusterSpec
   */
  additionalSettings?: V1AdditionalSettings;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  allowChaos?: boolean;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  auraInstanceDnsName?: string;
  /**
   * This is set when the cluster is the main resource backing the aura instance
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  auraInstanceId?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  clusterId?: string;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jClusterSpec
   */
  coreCount?: number;
  /**
   *
   * @type {V1DiskSpec}
   * @memberof V1Neo4jClusterSpec
   */
  coreDisk?: V1DiskSpec;
  /**
   *
   * @type {V1MemorySpec}
   * @memberof V1Neo4jClusterSpec
   */
  coreMemory?: V1MemorySpec;
  /**
   * KMS Key reference for Customer Managed Encryption Keys (CMEK).
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  darConfig?: string;
  /**
   *
   * @type {V1ClusterDatabasesReconcilerSpec}
   * @memberof V1Neo4jClusterSpec
   */
  databasesSpec?: V1ClusterDatabasesReconcilerSpec;
  /**
   *
   * @type {Array<string>}
   * @memberof V1Neo4jClusterSpec
   */
  dbids?: Array<string>;
  /**
   * If set, specifies the default Cypher Version the database is created with
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  defaultCypherVersion?: string;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  dnsName?: string;
  /**
   * Allows us to define additionally added neo4j configuration
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  extraConfig?: string;
  /**
   * Feature toggles, to roll out experimental features
   * @type {Array<string>}
   * @memberof V1Neo4jClusterSpec
   */
  features?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  fineGrainedRBAC?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  multiDatabaseCluster?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  multiTenantCluster?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  multiZone?: boolean;
  /**
   * This is the Neo4j major version, e.g. "3", "4" or "5"
   * @type {V1Neo4jMajorVersion}
   * @memberof V1Neo4jClusterSpec
   */
  neo4jMajorVersion?: V1Neo4jMajorVersion;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  password?: string;
  /**
   * Control whether the cluster is running or not.
   * @type {GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState}
   * @memberof V1Neo4jClusterSpec
   */
  pause?: GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseState;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jClusterSpec
   */
  publicBoltPort?: number;
  /**
   *
   * @type {Array<V1ResourcePolicyOverride>}
   * @memberof V1Neo4jClusterSpec
   */
  resourcePolicyOverrides?: Array<V1ResourcePolicyOverride>;
  /**
   *
   * @type {number}
   * @memberof V1Neo4jClusterSpec
   */
  secondaryCoreCount?: number;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  secretName?: string;
  /**
   *
   * @type {V1SourceBackup}
   * @memberof V1Neo4jClusterSpec
   */
  sourceBackupv2?: V1SourceBackup;
  /**
   *
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  ssoConfig?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof V1Neo4jClusterSpec
   */
  ssoInternalConfig?: { [key: string]: string };
  /**
   *
   * @type {V1StorageClassSettings}
   * @memberof V1Neo4jClusterSpec
   */
  storageClassSettings?: V1StorageClassSettings;
  /**
   * SuperLarge is a marker for databases that exceed a memory threshold (1 TiB)
   * and require special, ultramem nodes
   * @type {boolean}
   * @memberof V1Neo4jClusterSpec
   */
  superLarge?: boolean;
  /**
   * Which databases/raft groups should this cluster manage
   * @type {Array<string>}
   * @memberof V1Neo4jClusterSpec
   */
  tenantDatabases?: Array<string>;
  /**
   * Zone is only applicable if MultiZone is false, but since we don't have a way of validating CRDs (yet)
   * it should simply be ignored if MultiZone is true.
   * @type {string}
   * @memberof V1Neo4jClusterSpec
   */
  zone?: string;
}

/**
 * Check if a given object implements the V1Neo4jClusterSpec interface.
 */
export function instanceOfV1Neo4jClusterSpec(
  value: object,
): value is V1Neo4jClusterSpec {
  return true;
}

export function V1Neo4jClusterSpecFromJSON(json: any): V1Neo4jClusterSpec {
  return V1Neo4jClusterSpecFromJSONTyped(json, false);
}

export function V1Neo4jClusterSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jClusterSpec {
  if (json == null) {
    return json;
  }
  return {
    additionalSettings:
      json['additionalSettings'] == null
        ? undefined
        : V1AdditionalSettingsFromJSON(json['additionalSettings']),
    allowChaos: json['allowChaos'] == null ? undefined : json['allowChaos'],
    auraInstanceDnsName:
      json['auraInstanceDnsName'] == null
        ? undefined
        : json['auraInstanceDnsName'],
    auraInstanceId:
      json['auraInstanceId'] == null ? undefined : json['auraInstanceId'],
    clusterId: json['clusterId'] == null ? undefined : json['clusterId'],
    coreCount: json['coreCount'] == null ? undefined : json['coreCount'],
    coreDisk:
      json['coreDisk'] == null
        ? undefined
        : V1DiskSpecFromJSON(json['coreDisk']),
    coreMemory:
      json['coreMemory'] == null
        ? undefined
        : V1MemorySpecFromJSON(json['coreMemory']),
    darConfig: json['darConfig'] == null ? undefined : json['darConfig'],
    databasesSpec:
      json['databasesSpec'] == null
        ? undefined
        : V1ClusterDatabasesReconcilerSpecFromJSON(json['databasesSpec']),
    dbids: json['dbids'] == null ? undefined : json['dbids'],
    defaultCypherVersion:
      json['defaultCypherVersion'] == null
        ? undefined
        : json['defaultCypherVersion'],
    dnsName: json['dnsName'] == null ? undefined : json['dnsName'],
    extraConfig: json['extraConfig'] == null ? undefined : json['extraConfig'],
    features: json['features'] == null ? undefined : json['features'],
    fineGrainedRBAC:
      json['fineGrainedRBAC'] == null ? undefined : json['fineGrainedRBAC'],
    multiDatabaseCluster:
      json['multiDatabaseCluster'] == null
        ? undefined
        : json['multiDatabaseCluster'],
    multiTenantCluster:
      json['multiTenantCluster'] == null
        ? undefined
        : json['multiTenantCluster'],
    multiZone: json['multiZone'] == null ? undefined : json['multiZone'],
    neo4jMajorVersion:
      json['neo4jMajorVersion'] == null
        ? undefined
        : V1Neo4jMajorVersionFromJSON(json['neo4jMajorVersion']),
    password: json['password'] == null ? undefined : json['password'],
    pause:
      json['pause'] == null
        ? undefined
        : GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateFromJSON(
            json['pause'],
          ),
    publicBoltPort:
      json['publicBoltPort'] == null ? undefined : json['publicBoltPort'],
    resourcePolicyOverrides:
      json['resourcePolicyOverrides'] == null
        ? undefined
        : (json['resourcePolicyOverrides'] as Array<any>).map(
            V1ResourcePolicyOverrideFromJSON,
          ),
    secondaryCoreCount:
      json['secondaryCoreCount'] == null
        ? undefined
        : json['secondaryCoreCount'],
    secretName: json['secretName'] == null ? undefined : json['secretName'],
    sourceBackupv2:
      json['sourceBackupv2'] == null
        ? undefined
        : V1SourceBackupFromJSON(json['sourceBackupv2']),
    ssoConfig: json['ssoConfig'] == null ? undefined : json['ssoConfig'],
    ssoInternalConfig:
      json['ssoInternalConfig'] == null ? undefined : json['ssoInternalConfig'],
    storageClassSettings:
      json['storageClassSettings'] == null
        ? undefined
        : V1StorageClassSettingsFromJSON(json['storageClassSettings']),
    superLarge: json['superLarge'] == null ? undefined : json['superLarge'],
    tenantDatabases:
      json['tenantDatabases'] == null ? undefined : json['tenantDatabases'],
    zone: json['zone'] == null ? undefined : json['zone'],
  };
}

export function V1Neo4jClusterSpecToJSON(json: any): V1Neo4jClusterSpec {
  return V1Neo4jClusterSpecToJSONTyped(json, false);
}

export function V1Neo4jClusterSpecToJSONTyped(
  value?: V1Neo4jClusterSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    additionalSettings: V1AdditionalSettingsToJSON(value['additionalSettings']),
    allowChaos: value['allowChaos'],
    auraInstanceDnsName: value['auraInstanceDnsName'],
    auraInstanceId: value['auraInstanceId'],
    clusterId: value['clusterId'],
    coreCount: value['coreCount'],
    coreDisk: V1DiskSpecToJSON(value['coreDisk']),
    coreMemory: V1MemorySpecToJSON(value['coreMemory']),
    darConfig: value['darConfig'],
    databasesSpec: V1ClusterDatabasesReconcilerSpecToJSON(
      value['databasesSpec'],
    ),
    dbids: value['dbids'],
    defaultCypherVersion: value['defaultCypherVersion'],
    dnsName: value['dnsName'],
    extraConfig: value['extraConfig'],
    features: value['features'],
    fineGrainedRBAC: value['fineGrainedRBAC'],
    multiDatabaseCluster: value['multiDatabaseCluster'],
    multiTenantCluster: value['multiTenantCluster'],
    multiZone: value['multiZone'],
    neo4jMajorVersion: V1Neo4jMajorVersionToJSON(value['neo4jMajorVersion']),
    password: value['password'],
    pause:
      GithubComNeoTechnologyNeo4jCloudLibsNeo4jDatabaseClientsetApisNeo4jIoV1PauseStateToJSON(
        value['pause'],
      ),
    publicBoltPort: value['publicBoltPort'],
    resourcePolicyOverrides:
      value['resourcePolicyOverrides'] == null
        ? undefined
        : (value['resourcePolicyOverrides'] as Array<any>).map(
            V1ResourcePolicyOverrideToJSON,
          ),
    secondaryCoreCount: value['secondaryCoreCount'],
    secretName: value['secretName'],
    sourceBackupv2: V1SourceBackupToJSON(value['sourceBackupv2']),
    ssoConfig: value['ssoConfig'],
    ssoInternalConfig: value['ssoInternalConfig'],
    storageClassSettings: V1StorageClassSettingsToJSON(
      value['storageClassSettings'],
    ),
    superLarge: value['superLarge'],
    tenantDatabases: value['tenantDatabases'],
    zone: value['zone'],
  };
}
